<template>
  <v-layout>
  <v-layout row wrap v-if="type === undefined" class="mt-3">
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/Admin/User">
            <v-icon>person</v-icon>
          </v-btn>
          <p>User Manager</p>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/Admin/Customer">
            <v-icon>mdi-account-group</v-icon>
          </v-btn>
          <p>Customer Manager</p>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/Admin/Supplier">
            <v-icon>assignment_ind</v-icon>
          </v-btn>
          <p>Supplier Manager</p>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/Admin/Vehicle">
            <v-icon>local_shipping</v-icon>
          </v-btn>
          <p>Vehicle Manager</p>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/Admin/Product">
            <v-icon>assignment</v-icon>
          </v-btn>
          <p>Product Template Manager</p>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/Admin/Device">
            <v-icon>router</v-icon>
          </v-btn>
          <p>Device Template Manager</p>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
      <v-card class="mx-2">
        <div class="text-xs-center">
          <v-btn color="primary" fab large to="/AuditLog">
            <v-icon>mdi-database-search</v-icon>
          </v-btn>
          <p>Audit Log</p>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
  <user-view v-if="type==='User'" xs12></user-view>
  <customer-view v-if="type==='Customer'" xs12></customer-view>
  <supplier-view v-if="type==='Supplier'" xs12></supplier-view>
  <product-view v-if="type==='Product'" xs12></product-view>
  <device-view v-if="type==='Device'" xs12></device-view>
  <vehicle-view v-if="type==='Vehicle'" xs12></vehicle-view>
  </v-layout>
</template>

<script>
export default {
  props: ['type']
}
</script>



// WEBPACK FOOTER //
// Admin.vue?1374ae1c